import './utilities/screen-sizes';
import './components/menu';
import runOnUserInteraction from './utilities/run-on-interaction';
import appendBuyFlowParams from './components/add-url-params';
import youtubeSchema from './components/youtube-schema';
import triggerEventTracking from './components/analytics/cta-events';
import triggerProviderTracking from './components/analytics/providers';
import triggerLinkTracking from './components/analytics/links';
import initializeRingpool from './modules/ringpool';
import medicareBanner from './components/medicare-banner';
import tippyTooltip from './components/tippy-tooltip';
import {loadBanners} from './components/promotions-banner/';


const userInteractionScripts = () => {
    appendBuyFlowParams();
    youtubeSchema();
    triggerEventTracking();
    triggerProviderTracking();
    triggerLinkTracking();
    initializeRingpool();
    medicareBanner();
    tippyTooltip();
    loadBanners();
}

runOnUserInteraction(userInteractionScripts);
